import UnventedHotWaterStorageVesselCommissioningInspectionForm from './UnventedHotWaterStorageVesselCommissioningInspectionForm';
import UnventedHotWaterStorageVesselCommissioningInspectionPDF from './UnventedHotWaterStorageVesselCommissioningInspectionPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';


export default {
  Form: UnventedHotWaterStorageVesselCommissioningInspectionForm,
  PDF: UnventedHotWaterStorageVesselCommissioningInspectionPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF,

};
